import { render, staticRenderFns } from "./ResearchReport.vue?vue&type=template&id=40561a4b&"
import script from "./ResearchReport.vue?vue&type=script&lang=js&"
export * from "./ResearchReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports